<template>
  <div class="delete-account-container">
    <img class="logo" src="@/assets/logo.svg" alt="Clavo" width="153" height="33" @click="$router.push({ path: '/login' })" />

    <div class="login-button">
      <div>
        <button class="clavo-button secondary" @click="register">
          {{ $t('signUp') }}
        </button>
      </div>
    </div>

    <div class="content-wrapper">
      <div class="goodbye-msg">
        <h1>
          {{ $t('whyYouResign') }}
        </h1>
        <p class="subtitle" />
        <!--
        <editable-input
          v-model="reviewInformation"
          :placeholder="$t('tellUsWhyYouResign')"
        />
        -->
        <div class="textarea-wrapper">
          <textarea v-model="reviewInformation" :placeholder="$t('tellUsWhyYouResign')" class="clavo-textarea" />
        </div>
        <button class="clavo-button primary" @click="submit">
          {{ $t('submit') }}
        </button>
      </div>

      <div class="image-wrapper">
        <div class="callout">
          <p>
            {{ $t('weAreSadYouHaveGone') + ' 😢' }}
          </p>
        </div>
        <img src="@/assets/illustrations/sad-sloth.svg" alt="Clavo, a sloth with coffee" />
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/EventBus'
import ParseFunctions from '@/components/ParseFunctions'
import Constants from '@/components/Constants'

export default {
  name: 'AccountDeletion',
  components: {},
  mixins: [ParseFunctions, Constants],
  data() {
    return {
      reviewInformation: '',
      userId: '',
    }
  },
  created() {
    if (this.$route.query && this.$route.query.id) {
      this.userId = this.$route.query.id
    }
  },
  methods: {
    register() {
      this.$router.push({
        path: '/register',
      })
    },
    async submit() {
      if (this.reviewInformation) {
        let res = await this.sendUserFeedback(this.reviewInformation, this.userId, 'USER_RESIGNED_FEEDBACK')

        if (res.status === 'ok') {
          EventBus.$emit('new-info-bar-msg', {
            msg: this.$t('thankYouForSubmission'),
          })
          this.$router.push({
            path: '/login',
          })
        } else {
          this.showServerError(res)
        }
      } else {
        EventBus.$emit('new-info-bar-msg', {
          msg: this.$t('yourFeedbackIsImportant'),
          error: true,
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.delete-account-container {
  display: flex;
  flex-direction: column;

  .logo {
    align-self: flex-start;
    order: 0;
    margin: 30px;
    cursor: pointer;
  }

  .login-button {
    align-self: flex-end;
    margin: -66px 30px 24px 30px;
    @include respond-below(sm) {
      display: none;
    }
  }
  .content-wrapper {
    max-width: 960px;
    width: 100%;
    padding: 0 30px;
    margin: 100px auto 0 auto;
    display: flex;
    flex-direction: row;

    @include respond-below(sm) {
      flex-direction: column;
    }

    .goodbye-msg {
      align-self: flex-start;
      flex: 3;
      h1 {
        margin-bottom: 36px;
      }
      p {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 12px;
      }
      button {
        @include respond-below(sm) {
          width: 100%;
        }
      }
      .textarea-wrapper {
        margin-bottom: 24px;
        textarea {
          min-height: 18 * 5+20px;
        }
      }
      @include respond-below(sm) {
        width: 100%;
      }
    }

    .image-wrapper {
      flex: 3;
      display: block;
      align-self: center;
      text-align: center;
      margin-left: 60px;
      @include respond-below(sm) {
        margin-top: 36px;
        margin-bottom: 60px;
        margin-left: 0;
      }
      img {
        transform: scale(0.95);

        // object-fit: none;
      }

      .callout {
        display: flex;
        justify-content: flex-start;
        p {
          display: block;
          padding: 12px 24px;
          background-color: $white-lilac;
          color: $black;
          font-family: $bold;
          font-size: 20px;
          line-height: 25px;
          border-radius: 10px;
          margin: 0 0 20px 0;
          position: relative;
          text-align: left;

          .emoji {
            margin-right: 2px;
          }
          &:after {
            content: '';
            bottom: -30px;
            left: 35%;
            //right: 0px;
            width: 30px;
            height: 30px;
            position: absolute;
            display: block;
            background: url(~@/assets/layout/callout-tip.svg) no-repeat;
          }
        }
      }
    }
  }
}
</style>
